import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  Typography
} from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { DialogWrapper } from '../DialogWrapper';
import { useEscKey } from '../../../hooks/useEscKey';

interface FilePreviewDialogProps {
  previewFile: any;
  onPreviewClose: () => void;
  previewLoading: boolean;
  onFileDownload: (file: any) => void;
}

export const FilePreviewDialog: React.FC<FilePreviewDialogProps> = ({
  previewFile,
  onPreviewClose,
  previewLoading,
  onFileDownload
}) => {
  useEscKey(previewFile.open, onPreviewClose);

  if (!previewFile.open) return null;

  const renderPreview = () => {
    if (previewLoading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400 }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Dosya yükleniyor...</Typography>
        </Box>
      );
    }

    switch (previewFile.type) {
      case 'image':
        return (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img
              src={previewFile.blobUrl}
              alt={previewFile.file?.name}
              style={{ maxWidth: '100%', maxHeight: '400px', objectFit: 'contain' }}
            />
          </Box>
        );
      
      case 'pdf':
        return (
          <Box sx={{ height: 500 }}>
            <iframe
              src={previewFile.blobUrl}
              width="100%"
              height="100%"
              title={previewFile.file?.name}
            />
          </Box>
        );
      
      case 'text':
        return (
          <Box sx={{ height: 400, overflow: 'auto' }}>
            <iframe
              src={previewFile.blobUrl}
              width="100%"
              height="100%"
              title={previewFile.file?.name}
            />
          </Box>
        );
      
      default:
        return (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h6" color="text.secondary">
              Bu dosya türü önizlenemiyor
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Dosyayı indirerek görüntüleyebilirsiniz.
            </Typography>
          </Box>
        );
    }
  };

  return (
    <DialogWrapper  
      open={previewFile.open} 
      onClose={onPreviewClose} 
      maxWidth="lg" 
      fullWidth
      PaperProps={{ sx: { height: '80vh' } }}
    >
      <DialogTitle>
        {previewFile.file?.name || 'Dosya Önizleme'}
      </DialogTitle>
      <DialogContent>
        {renderPreview()}
      </DialogContent>
      <DialogActions>
        <Button 
          startIcon={<DownloadIcon />}
          onClick={() => onFileDownload(previewFile.file)}
          variant="outlined"
        >
          İndir
        </Button>
        <Button onClick={onPreviewClose}>
          Kapat
        </Button>
      </DialogActions>
    </DialogWrapper>
  );
};